<script>
  import { createEventDispatcher,onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import { getJaugeValue } from "./data";
  import { getTrad,language } from './js/AppState';
  import SGMSApi from './js/SGMSApi';

  const dispatch = createEventDispatcher();

  let value = 0
  let scale = []

  onMount(() => {
    getJaugeValue($language)
    .then(data => {
      value = data.val
      scale = data.scale
    })
  })


  function handleClick(e) {

    SGMSApi.sendActionEvent(e, "JaugeNextBtn")

    dispatch('next')
  }

  $: money = 10000 * value / 100


</script>

<div class="jauge-screen" transition:fade>
  <div class="jauge-popup">
    <h3>{$getTrad("donation_status")}</h3>
    <!-- <h2>{money} €</h2> -->
    <div class="jauge-ctnr">
      <div class="jauge-outer">
        <div class="jauge">
          <div class="jauge-inner" style="height:{value}%"/>
        </div>
      </div>


      <div class="jauge-grads">
        <div class="jauge-grad" />
        <div class="jauge-grad-blue" style="height:{value}%" />
      </div>

      <div class="jauge-values">
        {#each scale as scale_value}
          <span>{scale_value}K</span>
        {/each}

      </div>
    </div>

    <button on:click={handleClick}>{$getTrad('next_btn')}</button>
  </div>
</div>


<style>
  .jauge-screen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(45, 68, 136, 0.8);
    z-index: 3;

    display: flex;
    align-items: flex-start;
    justify-content: center;

    overflow-y: auto;
  }

  .jauge-popup {
    position: relative;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%)  translateY(-50%);

    border-radius: 30px 30px 0 0;
    text-align: center;
    background: #fff;
    padding: 30px;
    width: 245px;

    /* margin: 30px; */
    /* margin-top: 120px; */
  }
  .jauge-popup::after {
    content: "";
    position: absolute;
    top: 99%;
    left: 0;
    right: 0;

    height: 50px;
    background: url('../images/white-bottom.png') no-repeat center center;
    background-size: 100% 100%;
  }

  h3 {
    text-transform: uppercase;
    color: #2D4488;
  }
  .jauge-ctnr {
    display: flex;
    justify-content: center;

    /* border: 1px solid  red; */
  }

  .jauge-grads {
    position: relative;
    /* border: 1px solid  red; */
    min-height: 100%;
    margin-top:     11px;
    margin-bottom:  11px;
    margin-left: 5px;

    width: 10px;

  }
  .jauge-grad,
  .jauge-grad-blue {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: repeating-linear-gradient(to top, #EFEFEF, #EFEFEF 2px, transparent 2px, transparent 8px);
  }
  .jauge-grad-blue::before {
    content: "";
    display: block;
    width: 25px;
    height: 2px;
    background: #2D4488;

    /* transform: translateY(-100%); */
  }


  .jauge-grad-blue {
    width: 10px;
    top: auto;
    background: repeating-linear-gradient(to top, #2D4488, #2D4488 2px, transparent 2px, transparent 8px);
    transition: height 1s;
  }




  .jauge-values {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
    /* margin: 5px 0; */
    margin-left: 20px;
    color: #B1B1B1;

  }


  .jauge-outer {
    background: #EFEFEF;
    width: 40px;
    height: 200px;
    padding: 8px;
    border: 2px solid rgba(151, 151, 151, 0.144);
    border-radius: 99px;
  }

  .jauge {
    position: relative;
    background: #fff;
    width: 100%;
    height: 100%;
    border-radius: 99px;
  }

  .jauge-inner {
    position: absolute;
    bottom: 0;
    border-radius: 99px;
    width: 100%;
    transition: height 1s;
    background: linear-gradient(to top, #4C00B2, #258EEA)
  }

  button{
    border: 1px solid #00458A;
    color: #00458A;
    background: #fff;
    font-size: 1em;

    border-radius: 99px;
    padding: 10px 30px;

    margin-top: 30px;

    text-transform: uppercase;
  }
  button:hover{
    color: #FFF;
    background: #00458A;
  }
</style>
